import React from "react";

function CustAuth() {
  return <div>Customer Auth Page</div>;
}

export default CustAuth;
